import React, { useState, useEffect } from "react";

import { Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  innerSect: {
    backgroundImage: "linear-gradient(45deg, white, white)",
    marginTop: "8rem",
    marginRight: "14rem",
    marginLeft: "14rem",
    // opacity: 0,
    willChange: "opacity",
    fontFamily: "Notos Sans KR",
    color: "black",
  },
  logoImg: {
    width: "100%",
    height: 250,
  },
}));

interface MainImgComponentProps {
  children: React.ReactNode | null | string | undefined;
}

function MainImgComponent() {
  const classes = useStyles();
  const theme = useTheme();
  const down_md = useMediaQuery(theme.breakpoints.down("md"));
  const up_xl = useMediaQuery(theme.breakpoints.up("xl"));
  return (
    <Grid item container className={classes.innerSect}>
      <Grid xs={12} item container justify={"center"}>
        <Grid xs={12} item style={{ padding: "10rem 12rem" }}>
          <img
            src={"/images/main/labor_main.svg"}
            style={{ width: "100%" }}
            alt={
              "(사)노동인권연대가 실시하는 노동인권문화제는 작년 제1회 노동인권문화제를 시작으로 부산 시민의 노동인권과 사회연대의식 함양을 통해 부산이 성숙한 민주시민사회를 선도하는 도시로 발전할 수 있도록 공모전을 실시하고, 문화제를 통해 부산 시민들의 노동인권과 사회연대의식을 고취시킴으로써 비정규직과 중소하청 노동자의 노동권익 향상에 기여하고 있습니다."
            }
          ></img>
        </Grid>
        {/* <Grid
          xs={12}
          item
          container
          // justify="center"
          style={{ padding: "6rem 4rem" }}
        >
          <Grid
            xs={4}
            item
            container
            justify={"center"}
            style={{
              padding: "2rem",
            }}
          >
     
            <img
              src={"/images/main/only_labor_main.svg"}
              className={classes.logoImg}
            ></img>
          </Grid>
          <Grid
            xs={8}
            item
            container
            alignContent={"center"}
            style={{
              padding: "2rem",
            }}
          >
            <h6
              style={{
                fontFamily: "Noto Sans KR",
                paddingBottom: "2rem",
                fontWeight: 400,
                letterSpacing: -1,
              }}
            >
              (사)노동인권연대가 실시하는 노동인권문화제는 작년 제1회
              노동인권문화제를 시작으로 부산 시민의 노동인권과 사회연대의식
              함양을 통해 부산이 성숙한 민주시민사회를 선도하는 도시로 발전할 수
              있도록 공모전을 실시하고, 문화제를 통해 부산 시민들의 노동인권과
              사회연대의식을 고취시킴으로써 비정규직과 중소하청 노동자의
              노동권익 향상에 기여하고 있습니다.
            </h6>
          </Grid>
        </Grid>  */}
      </Grid>
    </Grid>
  );
}

export default MainImgComponent;
